<template>
    <div v-if="booksInsights.length && !isEmpty(swiperOptions)" class="bi-carousel">
        <slot name="title" />
        <slot name="description" />
        <div slot="button-prev" class="swiper-button swiper-button-prev d-none d-sm-block" :class="`swiper-button-prev-${carouselId}`" />
        <div slot="button-next" class="swiper-button swiper-button-next d-none d-sm-block" :class="`swiper-button-next-${carouselId}`" />
        <swiper :options="swiperOptions">
            <swiper-slide
                v-for="(bookInsight, index) in booksInsights"
                :key="index"
                class="swiper-lazy"
                :data-background="bookInsight.background.shape ? bookInsight.background.shape : defaultBackgroundShape"
                :style="{ 'background-color' : bookInsight.background.color ? bookInsight.background.color : defaultBackgroundColor}"
            >
                <book-insight
                    lazy-loading
                    :book-insight="bookInsight"
                />
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import biBackgroundMixins from "@/mixins/biBackgroundMixins";

export default {
    name: "Carousel",
    components: {
        swiper,
        swiperSlide,
        bookInsight:() => import(/* webpackChunkName: "book-insight"*/ "@c/books-insights/carousel/book-insight")
    },
    mixins: [biBackgroundMixins],
    props: {
        booksInsights: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            carouselId: Math.random().toString(16).substring(2, 15),
            swiperOptions: null
        };
    },
    computed: {
        ...mapGetters({
            nonFictionSubscriptionDaysLeft: "UserMembership/getNonFictionSubscriptionDaysLeft"
        })
    },
    created() {
        this.swiperOptions = {
            loop: this.swiperShouldLoop(),
            slidesPerView: 4,
            spaceBetween: 15,
            threshold: 50,
            preloadImages: false,
            lazy: {
                loadPrevNext: true
            },
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            navigation: {
                nextEl: ".swiper-button-next-" + this.carouselId,
                prevEl: ".swiper-button-prev-" + this.carouselId
            },
            breakpoints: {
                991: {
                    slidesPerView: 3,
                    slidesPerGroup: 2
                },
                767: {
                    slidesPerView: 2,
                    slidesPerGroup: 1
                }
            },
            on: {
                slideChange() {
                    this.loopDestroy();
                    this.loopCreate();
                }
            }
        }
    },
    methods: {
        isEmpty: _isEmpty,
        swiperShouldLoop() {
            const mobileWidthSize = 767;
            const isMobileScreen = window.innerWidth < mobileWidthSize;
            const slidesPerView = isMobileScreen ? 2 : 4;

            if (isMobileScreen) {
                return this.booksInsights.length >= slidesPerView;
            }

            return this.booksInsights.length > slidesPerView;
        }
    }
}
</script>

<style lang="scss">
.bi-carousel {
    position: relative;

    h2 {
        color: white;
        font-size: 25px;
        font-weight: 600;
        line-height: 34px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @media (max-width: $md) {
            font-size: 20px;
            line-height: 29px;
        }

        a {
            color: white;
            font-weight: 600;
            font-size: 16px;
            line-height: 29px;
            text-decoration: none;
        }
    }

    p {
        color: white;
        font-size: 15px;
        line-height: 27px;

        @media (max-width: $md) {
            line-height: 20px;
        }
    }

    .swiper-wrapper {
        .swiper-slide {
            border-radius: 6px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: right bottom;

            .book-insight {
                max-width: 222px;
                margin: 0 auto;
            }
        }
    }

    .swiper-button {
        background-color: $medium-gray;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-image: url("~@assets/img/carousel-arrow.svg");
        background-size: 10px;
        background-position: center;
        background-repeat: no-repeat;
        box-shadow: 0 0 9px 0 rgba(0,0,0,0.1);
        bottom: 130px;
        top: initial;

        &:focus {
            outline: initial;
        }

        &.swiper-button-disabled {
            opacity: 0;
        }
    }

    .swiper-button-prev {
        transform: scaleX(-1);
        left: -20px;
    }

    .swiper-button-next {
        right: -20px;
    }

}
</style>
